<template>
  <div>
    <template v-if="loading">
      <div class="row">
        <div class="col-12 text-center">
          <div class="d-flex justify-content-center">
            <div class="loader"></div>
          </div>
          <h4 style="margin-top:2em; margin-bottom:2em;">Carregando...</h4>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="row d-flex align-items-end">

        <!-- Nome -->
        <div class="col-3 align-items-end">
          <base-input
            label="Nome"
            placeholder="Nome do Destino"
            v-model="model.nome"
          ></base-input>
        </div>

        <!-- Plataforma -->
        <div class="col-2 align-items-end">
          <div class="form-group">
            <label>Plataforma</label>
            <select
              class="form-control"
              v-model="model.plataforma"
              @change="alterarPlataforma"
            >
              <option value="WHATSAPP">WhatsApp</option>
              <option value="TELEGRAM">Telegram</option>
            </select>
          </div>
        </div>

        <!-- Tipo -->
        <div class="col-1 align-items-end">
          <div class="form-group">
            <label>Tipo</label>
            <select
              class="form-control"
              v-model="model.tipo"
            >
              <option value="GRUPO">Grupo</option>
              <option value="CANAL">Canal</option>
            </select>
          </div>
        </div>

        <!-- Código -->
        <div class="col-2 align-items-end">
          <base-input
            label="Código"
            placeholder="Código do Destino"
            v-model="model.codigo"
            disabled
          ></base-input>
        </div>

        <!-- Instância WhatsApp -->
        <div
          v-if="model.plataforma === 'WHATSAPP'"
          class="col-2 align-items-end"
        >
          <div class="form-group">
            <label>Instância</label>

            <select
              class="form-control"
              v-model="model.instancia_id"
            >
              <option :value="0">Selecione...</option>

              <option
                v-for="instancia in instancias"
                :key="instancia.id"
                :value="instancia.id"
              >
                {{ instancia.nome }}
              </option>
            </select>
          </div>
        </div>

        <!-- Bot Telegram -->
        <div
          v-if="model.plataforma === 'TELEGRAM'"
          class="col-3 align-items-end"
        >
          <div class="form-group">
            <label>Bot Telegram</label>

            <select
              class="form-control"
              v-model="model.telegram_bot_id"
            >
              <option :value="0">Selecione...</option>

              <option
                v-for="bot in telegramBots"
                :key="bot.id"
                :value="bot.id"
              >
                {{ bot.nome }}
              </option>
            </select>
          </div>
        </div>

        <!-- Ativo -->
        <div class="col-1 align-items-end">
          <div class="form-group">
            <bootstrap-toggle
              v-model="model.ativo"
              :options="{ on: 'Ativo', off: 'Inativo' }"
              :disabled="false"
            />
          </div>
        </div>

      </div>

      <!-- Tipos associados -->
      <!-- <div class="row col-12">
        <div class="tipos-titulo w-100">
          <span>Tipos Associados</span>
        </div>
      </div>

      <div class="row col-12">
        <div
          v-for="grupo in tiposGrupo"
          :key="grupo.id"
        >
          <div class="col-2 text-left">
            {{ grupo.nome }}
          </div>

          <div class="col-2 text-left">
            <bootstrap-toggle
              v-model="tipos[grupo.id]"
              :options="{ on: 'Sim', off: 'Não' }"
              :disabled="false"
              :label="grupo.id"
            />
          </div>
        </div>
      </div> -->

      <!-- Botões -->
      <div class="row col-12 text-center button-bar">
        <base-button
          slot="footer"
          type="secondary"
          fill
          @click="back"
        >
          Cancelar
        </base-button>

        <base-button
          slot="footer"
          type="primary"
          fill
          @click="salvar"
          :disabled="!id"
        >
          Salvar
        </base-button>
      </div>

    </template>
  </div>
</template>

<script>
import BootstrapToggle from 'vue-bootstrap-toggle'

export default {
  components: {
    BootstrapToggle
  },

  data() {
    return {
      columns: [
        { label: 'Id', field: 'id' },
        { label: 'Título', field: 'titulo' },
        { label: 'Texto', field: 'texto' },
        { label: 'Imagem', field: 'imagem' },
        { label: 'Publicação', field: 'datahora_publicacao' },
      ],

      userdata: {},

      model: {
        plataforma: 'WHATSAPP',
        instancia_id: 0,
        telegram_bot_id: 0,
        tipo: 'GRUPO'
      },

      // tiposGrupo: [],
      // tipos: {},

      loading_tipogrupo: true,
      loading_grupo: true,

      publicado: false,

      instancias: [],
      telegramBots: [],

      id: this.$route.params.id,

      searchOptions: {
        enabled: true,
        placeholder: 'Buscar...',
      },
    }
  },

  methods: {

    getUsuario() {
      try {
        let user = JSON.parse(localStorage.ADMIN_AUTH_USER)
        return user
      } catch (error) {
        console.error(error)
        localStorage.ADMIN_AUTH_USER = null
      }
    },

    back() {
      this.$router.push('/grupo')
    },

    alterarPlataforma() {

      if (this.model.plataforma === 'WHATSAPP') {
        this.model.telegram_bot_id = null

        if (!this.model.instancia_id) {
          this.model.instancia_id = 0
        }
      }

      if (this.model.plataforma === 'TELEGRAM') {
        this.model.instancia_id = null

        if (!this.model.telegram_bot_id) {
          this.model.telegram_bot_id = 0
        }
      }
    },

    validar() {

      if (!this.model.nome) {
        this.$swal(
          "Ops!",
          "Informe o nome do destino.",
          "warning"
        )

        return false
      }

      if (!this.model.plataforma) {
        this.$swal(
          "Ops!",
          "Informe a plataforma.",
          "warning"
        )

        return false
      }

      if (this.model.plataforma === 'WHATSAPP') {

        if (
          !this.model.instancia_id ||
          Number(this.model.instancia_id) <= 0
        ) {
          this.$swal(
            "Ops!",
            "Selecione a instância do WhatsApp.",
            "warning"
          )

          return false
        }
      }

      if (this.model.plataforma === 'TELEGRAM') {

        if (
          !this.model.telegram_bot_id ||
          Number(this.model.telegram_bot_id) <= 0
        ) {
          this.$swal(
            "Ops!",
            "Selecione o bot do Telegram.",
            "warning"
          )

          return false
        }
      }

      return true
    },

    salvar() {

      if (!this.validar()) {
        return
      }

      // this.model.tipos = this.tipos

      /*
       * Garantimos novamente a consistência antes de enviar.
       */

      if (this.model.plataforma === 'WHATSAPP') {
        this.model.telegram_bot_id = null
      }

      if (this.model.plataforma === 'TELEGRAM') {
        this.model.instancia_id = null
      }

      if (this.id) {

        this.$aws
          .post(
            'whatsapp/grupo/' + this.id,
            this.model
          )
          .then(response => {

            if (response.status == 200) {

              this.$swal(
                "Ok!",
                "Destino Salvo.",
                "success"
              )

              this.$router.push('/grupo')

            } else {

              this.$swal(
                "Ops!",
                "Ocorreu algum erro inesperado. (erro" +
                  response.status +
                  ")",
                "error"
              )
            }
          })
          .catch(error => {
            console.error(error)

            this.$swal(
              "Ops!",
              "Ocorreu um erro ao salvar o destino.",
              "error"
            )
          })
      }
    }
  },

  computed: {

    loading() {
      return (
        this.loading_grupo 
        // || this.loading_tipogrupo
      )
    }

  },

  mounted() {

    /*
     * Tipos de grupo
     */
    // this.$aws
    //   .get('whatsapp/tipogrupo')
    //   .then(response => {

    //     if (response.data) {
    //       this.tiposGrupo =
    //         JSON.parse(JSON.stringify(response.data))

    //       this.loading_tipogrupo = false
    //     }

    //   })
    //   .catch(error => {
    //     console.error(error)
    //   })


    /*
     * Instâncias WhatsApp
     */
    this.$aws
      .get('whatsapp/instancia')
      .then(response => {

        if (response.data) {
          this.instancias =
            JSON.parse(JSON.stringify(response.data))
        }

      })
      .catch(error => {
        console.error(error)
      })


    /*
     * Bots Telegram
     */
    this.$aws
      .get('telegram/bot')
      .then(response => {

        if (response.data) {
          this.telegramBots =
            JSON.parse(JSON.stringify(response.data))
        }

      })
      .catch(error => {
        console.error(error)
      })


    /*
     * Carrega destino
     */
    let user = this.getUsuario()

    if (user && user.id) {

      if (this.id) {

        this.$aws
          .get('whatsapp/grupo/' + this.id)
          .then(response => {

            if (response.data) {

              this.model = response.data

              /*
               * Retrocompatibilidade:
               *
               * registros antigos que ainda não possuam
               * plataforma são considerados WhatsApp.
               */
              if (!this.model.plataforma) {
                this.model.plataforma = 'WHATSAPP'
              }

              this.model.plataforma =
                this.model.plataforma.toUpperCase()

              if (!this.model.tipo) {
                this.model.tipo = 'GRUPO'
              }

              /*
               * Ajusta campos conforme plataforma.
               */
              if (this.model.plataforma === 'WHATSAPP') {

                this.model.telegram_bot_id = null

                if (!this.model.instancia_id) {
                  this.model.instancia_id = 0
                }

              } else if (
                this.model.plataforma === 'TELEGRAM'
              ) {

                this.model.instancia_id = null

                if (!this.model.telegram_bot_id) {
                  this.model.telegram_bot_id = 0
                }

              }

              /*
               * Tipos associados
               */
              // let mapa = {}

              // for (var idx in this.tiposGrupo) {

              //   if (
              //     this.model['tipos'].includes(
              //       this.tiposGrupo[idx]['id']
              //     )
              //   ) {
              //     mapa[this.tiposGrupo[idx]['id']] = true
              //   } else {
              //     mapa[this.tiposGrupo[idx]['id']] = false
              //   }
              // }

              // this.tipos = mapa
              this.loading_grupo = false
            }

          })
          .catch(error => {
            console.error(error)
          })
      }
    }
  },
}
</script>

<style lang="scss">
h3 {
  margin: 0px;
}

.dataTables_wrapper {
  margin-top: 20px;

  tbody td:last-child {
    text-align: center;
  }
}

.button-bar {
  border-top: 2px solid #FC7D59;
  margin-top: 2em;
  padding-top: 2em;
}

.tipos-titulo {
  border-bottom: 2px solid #2b3553;
  margin-bottom: 1em;
  margin-top: 2em;
}
</style>